// extracted by mini-css-extract-plugin
export default {"form":"UserStatusForm_form__pw-tc","check":"UserStatusForm_check__Z9v6Y","checkLabel":"UserStatusForm_checkLabel__yU4R0","warning":"UserStatusForm_warning__XB1yL"};